/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HttpFoundationStreamedResponse } from './HttpFoundationStreamedResponse';

export type HttpFoundationStreamedResponseApiRespoonse = {
    data?: HttpFoundationStreamedResponse;
    status?: HttpFoundationStreamedResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace HttpFoundationStreamedResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

